import React, { useEffect } from 'react';
import { I } from './Icons';

interface ModalProps {
  open:      boolean;
  onClose:   () => void;
  title:     React.ReactNode;
  sub?:      React.ReactNode;
  size?:     'md' | 'lg';
  footer?:   React.ReactNode;
  children:  React.ReactNode;
}

export const Modal: React.FC<ModalProps> = ({ open, onClose, title, sub, size = 'md', footer, children }) => {
  useEffect(() => {
    if (!open) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className={`modal ${size === 'lg' ? 'lg' : ''}`}
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-head">
          <div>
            <h2>{title}</h2>
            {sub && <div className="sub">{sub}</div>}
          </div>
          <button onClick={onClose} className="sae-icon-btn" aria-label="Cerrar">
            <I.X />
          </button>
        </div>

        <div className="modal-body">{children}</div>

        {footer && <div className="modal-foot">{footer}</div>}
      </div>
    </div>
  );
};
